module.exports = "mat-grid-tile{border:1px lightgray solid;border-radius:4px;text-align:center}mat-grid-tile div{width:100%}\n"